import type { DrawingSide } from '../../../domain/drawings';

/**
 * The FrontBackToggleButtonBarEvent is dispatched by the FrontBackToggleButtonBar when the user turns the drawing around.
 *
 * It stands in for the ToggleButtonBarEvent the bar raises, which the bar keeps to itself: a listener above it hears which side of the window is wanted, not which index was pressed. That the second button means the inside is the bar's own arrangement, and nothing above it should have to know the order they sit in.
 */
export default class FrontBackToggleButtonBarEvent extends Event {
	/**
	 * The static DRAWING_SIDE_CHANGED type is dispatched when the user picks a side.
	 *
	 * Example: addEventListener(FrontBackToggleButtonBarEvent.DRAWING_SIDE_CHANGED, (event: FrontBackToggleButtonBarEvent) => {});
	 */
	public static DRAWING_SIDE_CHANGED = 'FrontBackToggleButtonBarEvent.drawingSideChanged';

	/** The side of the window the user asked to see. */
	public side: DrawingSide;

	public constructor(side: DrawingSide = 'outside') {
		super(FrontBackToggleButtonBarEvent.DRAWING_SIDE_CHANGED, { bubbles: true });
		this.side = side;
	}
}
